$(document).ready(function(){
   $('.desktopslider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 300,        
      infinite: true,
      arrows: true,
      prevArrow: '<div class="slide-prev"><svg width="25" height="49" viewBox="0 0 30 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.81474 51.7487L26.5635 27L1.81474 2.25126" stroke="#282828" stroke-width="4"/></svg></div>',
      nextArrow: '<div class="slide-next"><svg width="25" height="49" viewBox="0 0 30 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.81474 51.7487L26.5635 27L1.81474 2.25126" stroke="#282828" stroke-width="4"/></svg></div>',   
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
   });


  // accordian
   $(document).ready(function() {
   $(".defaultopem").click(); 
  });
   $(".cst_accordion_head").click(function() {
        $(".cst_accordion_body").is(":visible") && ($(".cst_accordion_body").slideUp(300), $(".plusminus").text("+"), $('.cst_accordion_head').removeClass("active")), $(this).next(".cst_accordion_body").is(":visible") ? ($(this).next(".cst_accordion_body").slideUp(300), $(this).children(".plusminus").text("+")) : ($(this).next(".cst_accordion_body").slideDown(300), $(this).children(".plusminus").text("-"), $(this).addClass("active"))
    });
});

